export default function PlusIconWithoutCircle(props) {
  return (
    <svg
      width={"64" || props.width}
      height={"64" || props.height}
      viewBox="0 0 64 64"
      fill={"none" || props.fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53.3332 32.0003C53.3332 34.2664 51.4967 36.1029 49.2306 36.1029H36.1024V49.2311C36.1024 51.4971 34.2659 53.3337 31.9998 53.3337C29.7338 53.3337 27.8973 51.4971 27.8973 49.2311V36.1029H14.7691C12.503 36.1029 10.6665 34.2664 10.6665 32.0003C10.6665 29.7343 12.503 27.8978 14.7691 27.8978H27.8973V14.7696C27.8973 12.5035 29.7338 10.667 31.9998 10.667C34.2659 10.667 36.1024 12.5035 36.1024 14.7696V27.8978H49.2306C51.4967 27.8978 53.3332 29.7343 53.3332 32.0003Z"
        fill="#5A646E"
      />
    </svg>
  )
}
